import {useState} from "react";
import {useSingleFlight} from "utils/useSingleFlight";
import {SponsorApi, type SponsorWithdrawalReceipt} from "./SponsorApi";
import {isSponsorWithdrawalDraftComplete, sponsorWithdrawalError, type SponsorWithdrawalError} from "./sponsorWithdrawal";

export function useSponsorWithdrawal(bookingId: string, initialName: string, onReceived: () => void) {
	const [name, setName] = useState(initialName);
	// Drives the confirm button's `aria-disabled`, never `disabled`: a disabled button drops the focus
	// it holds out of the dialog (kitecorp/transferify-ui#3079). The flight below is what refuses a
	// second send, by joining a press made meanwhile to the one already running.
	const [submitting, setSubmitting] = useState(false);
	const [receipt, setReceipt] = useState<SponsorWithdrawalReceipt | null>(null);
	const [error, setError] = useState<SponsorWithdrawalError | null>(null);
	const flight = useSingleFlight();
	const draftComplete = isSponsorWithdrawalDraftComplete(name);
	const submit = () => flight.run(async () => {
		if (!draftComplete) return;
		setSubmitting(true);
		setError(null);
		try {
			setReceipt(await SponsorApi.withdraw(bookingId, name));
			onReceived();
		} catch (failure) {
			setError(sponsorWithdrawalError(failure));
		} finally {
			setSubmitting(false);
		}
	});
	return {name, setName, submitting, receipt, error, draftComplete, submit};
}
